import { useAuth } from '../../context/AuthContext';
import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Avatar from '../../components/ui/Avatar';
import { IconDeviceLaptop, IconLogout } from '@tabler/icons-react';

export default function Sessions() {
  const { user, userProfile } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 480, margin: '0 auto' }}>
        <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 24 }}>Sessions</h1>

        <Card style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 14 }}>Current session</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: 'var(--radius-md)', background: 'var(--color-success-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <IconDeviceLaptop size={20} color="var(--color-success)" stroke={1.5} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, color: 'var(--color-text-primary)', marginBottom: 2 }}>Web browser</div>
              <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)' }}>{user?.email} · Active now</div>
            </div>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-success)' }} />
          </div>
        </Card>

        <Card style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 10 }}>Account</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
            <Avatar name={userProfile?.name} photoURL={userProfile?.photoURL} size="md" />
            <div>
              <div style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>{userProfile?.name}</div>
              <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)', marginTop: 1 }}>{user?.email}</div>
            </div>
          </div>
          <Button
            variant="danger-outline"
            icon={<IconLogout size={14} stroke={1.5} />}
            onClick={handleSignOut}
          >
            Sign out
          </Button>
        </Card>
      </div>
    </Layout>
  );
}